import { mediaQueries } from 'shared/breakpoints';
import styled, { css } from 'styled-components';

export const MapWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 706px;
`;
